"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductOverviewApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class ProductOverviewApi extends runtime.BaseAPI {
    /**
     * 加入商品到購物車
     */
    productOverviewAddToCartPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/AddToCart`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.AddToCartRequestToJSON)(requestParameters['addToCartRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 加入商品到購物車
     */
    productOverviewAddToCartPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewAddToCartPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取消訂單
     */
    productOverviewCancelOrderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/CancelOrder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CancelOrderRequestToJSON)(requestParameters['cancelOrderRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取消訂單
     */
    productOverviewCancelOrderPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewCancelOrderPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 檢查優惠券是否過期
     */
    productOverviewCheckCouponExpiryPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/CheckCouponExpiry`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CheckCouponExpiryRequestToJSON)(requestParameters['checkCouponExpiryRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 檢查優惠券是否過期
     */
    productOverviewCheckCouponExpiryPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewCheckCouponExpiryPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 清空購物車
     */
    productOverviewClearCartDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['memberNo'] != null) {
                queryParameters['memberNo'] = requestParameters['memberNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/ClearCart`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 清空購物車
     */
    productOverviewClearCartDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewClearCartDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productOverviewGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    productOverviewGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productOverviewGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-選單導覽
     */
    productOverviewGetBreadcrumbBytagIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['tagId'] != null) {
                queryParameters['tagId'] = requestParameters['tagId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetBreadcrumbBytagId`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-選單導覽
     */
    productOverviewGetBreadcrumbBytagIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetBreadcrumbBytagIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢會員購物車清單
     */
    productOverviewGetCartItemsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['memberNo'] != null) {
                queryParameters['memberNo'] = requestParameters['memberNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetCartItems`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢會員購物車清單
     */
    productOverviewGetCartItemsGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetCartItemsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 包裝方式/取貨方式
     */
    productOverviewGetCodeRbListGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetCodeRbList`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 包裝方式/取貨方式
     */
    productOverviewGetCodeRbListGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetCodeRbListGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-商品詳情-使用代號
     */
    productOverviewGetDetailByIdPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetDetailById`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-商品詳情-使用代號
     */
    productOverviewGetDetailByIdPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetDetailByIdPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-商品詳情
     */
    productOverviewGetDetailPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            if (requestParameters['member'] != null) {
                queryParameters['member'] = requestParameters['member'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetDetail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-商品詳情
     */
    productOverviewGetDetailPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetDetailPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-我要詢價
     */
    productOverviewGetInquiryGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetInquiry`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-我要詢價
     */
    productOverviewGetInquiryGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productOverviewGetInquiryGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 商品明細-優惠券列表
     */
    productOverviewGetMaterialCouponGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['materialNo'] != null) {
                queryParameters['materialNo'] = requestParameters['materialNo'];
            }
            if (requestParameters['member'] != null) {
                queryParameters['member'] = requestParameters['member'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetMaterialCoupon`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 商品明細-優惠券列表
     */
    productOverviewGetMaterialCouponGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetMaterialCouponGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢商品規格庫存（供前端重新付款前庫存驗證使用）
     */
    productOverviewGetMaterialSpecificationGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['materialNo'] != null) {
                queryParameters['materialNo'] = requestParameters['materialNo'];
            }
            if (requestParameters['colorNo'] != null) {
                queryParameters['colorNo'] = requestParameters['colorNo'];
            }
            if (requestParameters['specNo'] != null) {
                queryParameters['specNo'] = requestParameters['specNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetMaterialSpecification`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢商品規格庫存（供前端重新付款前庫存驗證使用）
     */
    productOverviewGetMaterialSpecificationGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetMaterialSpecificationGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-選單
     */
    productOverviewGetMenuGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetMenu`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-選單
     */
    productOverviewGetMenuGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.productOverviewGetMenuGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 結帳頁面-訂單層級優惠券（包含全站套用和可選擇的優惠券）
     */
    productOverviewGetOrderCouponGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['member'] != null) {
                queryParameters['member'] = requestParameters['member'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetOrderCoupon`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 結帳頁面-訂單層級優惠券（包含全站套用和可選擇的優惠券）
     */
    productOverviewGetOrderCouponGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetOrderCouponGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productOverviewGetOrderGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            if (requestParameters['id'] != null) {
                queryParameters['id'] = requestParameters['id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetOrder`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    productOverviewGetOrderGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetOrderGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-分頁顯示
     */
    productOverviewGetPagePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetPage`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ProductOverviewSearchModelToJSON)(requestParameters['productOverviewSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-分頁顯示
     */
    productOverviewGetPagePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetPagePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢會員的未付款訂單
     */
    productOverviewGetPendingOrderGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['memberNo'] != null) {
                queryParameters['memberNo'] = requestParameters['memberNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetPendingOrder`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢會員的未付款訂單
     */
    productOverviewGetPendingOrderGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetPendingOrderGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢單一優惠券詳細資料
     */
    productOverviewGetPromotionDiscountGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['promotionDiscountNo'] != null) {
                queryParameters['promotionDiscountNo'] = requestParameters['promotionDiscountNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetPromotionDiscount`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢單一優惠券詳細資料
     */
    productOverviewGetPromotionDiscountGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetPromotionDiscountGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 收件地址
     */
    productOverviewGetShippingAddressGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['member'] != null) {
                queryParameters['member'] = requestParameters['member'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/GetShippingAddress`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 收件地址
     */
    productOverviewGetShippingAddressGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewGetShippingAddressGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-購物車結帳
     */
    productOverviewPostCheckoutPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/PostCheckout`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ShoppingCheckoutRequestToJSON)(requestParameters['shoppingCheckoutRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-購物車結帳
     */
    productOverviewPostCheckoutPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewPostCheckoutPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 網頁前端-商品總覽-我要詢價
     */
    productOverviewPostInquiryPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['productNo'] != null) {
                formParams.append('ProductNo', requestParameters['productNo']);
            }
            if (requestParameters['printRange'] != null) {
                formParams.append('PrintRange', requestParameters['printRange']);
            }
            if (requestParameters['printMethod'] != null) {
                formParams.append('PrintMethod', requestParameters['printMethod']);
            }
            if (requestParameters['postProcessing'] != null) {
                formParams.append('PostProcessing', requestParameters['postProcessing']);
            }
            if (requestParameters['shippingTime'] != null) {
                formParams.append('ShippingTime', requestParameters['shippingTime']);
            }
            if (requestParameters['image'] != null) {
                formParams.append('Image', requestParameters['image']);
            }
            if (requestParameters['note'] != null) {
                formParams.append('Note', requestParameters['note']);
            }
            if (requestParameters['name'] != null) {
                formParams.append('Name', requestParameters['name']);
            }
            if (requestParameters['telPhone'] != null) {
                formParams.append('TelPhone', requestParameters['telPhone']);
            }
            if (requestParameters['mail'] != null) {
                formParams.append('Mail', requestParameters['mail']);
            }
            if (requestParameters['quantity'] != null) {
                formParams.append('Quantity', requestParameters['quantity']);
            }
            const response = yield this.request({
                path: `/ProductOverview/PostInquiry`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 網頁前端-商品總覽-我要詢價
     */
    productOverviewPostInquiryPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewPostInquiryPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 重新下單（複製付款失敗訂單，產生新訂單編號）  適用於付款失敗（C1）的訂單，相同訂單編號無法再次付款，需複製後建立新訂單  驗證通過後完整複製原訂單（商品 + 優惠券金額完全相同），確保與原訂單一致  驗證項目：訂單建立時限、商品狀態/庫存、優惠券有效期、MinQuantity 門檻
     */
    productOverviewReOrderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/ReOrder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 重新下單（複製付款失敗訂單，產生新訂單編號）  適用於付款失敗（C1）的訂單，相同訂單編號無法再次付款，需複製後建立新訂單  驗證通過後完整複製原訂單（商品 + 優惠券金額完全相同），確保與原訂單一致  驗證項目：訂單建立時限、商品狀態/庫存、優惠券有效期、MinQuantity 門檻
     */
    productOverviewReOrderPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewReOrderPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 移除購物車商品
     */
    productOverviewRemoveCartItemDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['cartItemNo'] != null) {
                queryParameters['cartItemNo'] = requestParameters['cartItemNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/RemoveCartItem`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 移除購物車商品
     */
    productOverviewRemoveCartItemDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewRemoveCartItemDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 更新購物車商品優惠券
     */
    productOverviewUpdateCartItemCouponPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/UpdateCartItemCoupon`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UpdateCartCouponRequestToJSON)(requestParameters['updateCartCouponRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 更新購物車商品優惠券
     */
    productOverviewUpdateCartItemCouponPut() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewUpdateCartItemCouponPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 更新購物車商品數量
     */
    productOverviewUpdateCartItemQuantityPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/UpdateCartItemQuantity`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.UpdateCartItemRequestToJSON)(requestParameters['updateCartItemRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 更新購物車商品數量
     */
    productOverviewUpdateCartItemQuantityPut() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewUpdateCartItemQuantityPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    productOverviewValidateCouponCodeGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['code'] != null) {
                queryParameters['code'] = requestParameters['code'];
            }
            if (requestParameters['materialNo'] != null) {
                queryParameters['materialNo'] = requestParameters['materialNo'];
            }
            if (requestParameters['member'] != null) {
                queryParameters['member'] = requestParameters['member'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/ValidateCouponCode`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    productOverviewValidateCouponCodeGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewValidateCouponCodeGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 付款前驗證訂單（超過保留天數自動取消；庫存不足回傳錯誤）  前端在呼叫 CreateCreditCardPayment 之前必須先呼叫此 API
     */
    productOverviewValidateOrderForPaymentPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/ProductOverview/ValidateOrderForPayment`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ValidateOrderForPaymentRequestToJSON)(requestParameters['validateOrderForPaymentRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 付款前驗證訂單（超過保留天數自動取消；庫存不足回傳錯誤）  前端在呼叫 CreateCreditCardPayment 之前必須先呼叫此 API
     */
    productOverviewValidateOrderForPaymentPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.productOverviewValidateOrderForPaymentPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.ProductOverviewApi = ProductOverviewApi;
